export enum PuiMessageType {
  Error = <any>'danger',
  Info = <any>'info',
  Success = <any>'success',
  Warning = <any>'warning'
};
